import { metrics } from '@atlassian/browser-metrics';

export const automationSummaryPageLoad = metrics.pageLoad({
	key: 'service-management.automation.summary',
});

export const automationEditRulePageLoad = metrics.pageLoad({
	key: 'service-management.automation.edit-rule',
});

export const automationCreateRulePageLoad = metrics.pageLoad({
	key: 'service-management.automation.create-rule',
});

export const automationCopyRulePageLoad = metrics.pageLoad({
	key: 'service-management.automation.copy-rule',
});

export const automationViewLogPageLoad = metrics.pageLoad({
	key: 'service-management.automation.log',
});
